module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-clock-o',\n    title: 'Time',\n    description: 'Add-on for us that are paid-by-the-hour, as well as for contracting firms that assign tasks to consultant(s) and charge clients by the hour for their time.'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/2-time/time.section-header.html
// module id = 4082
// module chunks = 86